// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-create-form .custom-control-label {\n  margin-top: 6px; }\n  .user-create-form .custom-control-label::before, .user-create-form .custom-control-label::after {\n    top: 0.15rem; }\n", ""]);
// Exports
module.exports = exports;
